import React, { useState } from 'react';
import Styled from 'styled-components';
import { Link, useHistory } from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';
import Applet, { AppletContainer } from '../../Components/Applet';
import WelcomeToDavie from '../../Components/WelcomeToDavie';
import { useAuth } from '../../Contexts/AuthContext';
import { StyledButton } from '../../Components/Generics.styled';

const LoginContainer = Styled.div`
width: 100%;
height: 900px;

`;

const FormName = Styled.div`
text-align: left;
font-size: 23px;
letter-spacing: 0.77px;
color: #000000DE;
opacity: 1;
padding-left: 15px;
padding-top: 11px;
`;

const LoginTextFieldContainer = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 25px;
  margin-left: 15px;
  margin-right: 15px;
`;

const CreateAccountLink = Styled(Link)`
letter-spacing: 0px;
color: #0000EE;


`;

const ForgotPasswordLink = Styled(Link)`
letter-spacing: 0px;
color: #3F51B5;
opacity: 1;
display: flex;
justify-content: center;
padding-top: 20px;
padding-bottom: 20px;


`;

const WelcomeText = Styled.div`
width: 100%;
max-width: 600px;
margin-left: auto;
margin-right: auto;
margin-bottom: 30px;
text-align: left;
letter-spacing: 0px;
opacity: 1;

`;

const Login = () => {
    const [values, setValues] = useState({
        password: '',
        email: '',
        showPassword: false,
    });
    const initialPostDataVals = {
        error: false,
        success: false,
        isLoading: false,
        message: [],
    };

    const [postData, setPostData] = useState({ ...initialPostDataVals });

    const { email, password } = { ...values };

    const { login } = useAuth();

    const history = useHistory();

    const handleChange = (prop) => (event) => {
        setPostData({ ...initialPostDataVals });
        setValues({ ...values, [prop]: event.target.value, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleLogin = async () => {
        try {
            setPostData({ ...postData, isLoading: true });
            const resp = await login(email, password);
            localStorage.setItem('firstTimeSignIn', true);
            if (!resp.data.authenticated) {
                setPostData({
                    ...postData,
                    isLoading: false,
                    success: false,
                    error: true,
                    message: ['Email or Password is invalid.'],
                });
            }
        } catch (error) {
            setPostData({
                ...postData,
                isLoading: false,
                success: false,
                error: true,
                message: ['Something went wrong, please try again later.'],
            });
        }
    };

    return (
        <LoginContainer>
            <WelcomeToDavie />
            <AppletContainer>
                <WelcomeText>
                    If you don’t have an account simply answer a few questions and you’ll be ready
                    to reach new customers.{' '}
                    <CreateAccountLink to="/aboutYourBusiness/plan">Sign Up Now!</CreateAccountLink>
                </WelcomeText>

                <Applet height="410px">
                    <FormName>Log In</FormName>
                    <LoginTextFieldContainer>
                        <TextField
                            error={!email}
                            helperText={!email ? 'Email cannot be empty' : ''}
                            id="email-login"
                            label="Email Address"
                            defaultValue={values.email}
                            onChange={handleChange('email')}
                            variant="outlined"
                            required
                        />
                        <br />
                        <TextField
                            required
                            error={!password}
                            helperText={!password ? 'Password cannot be empty' : ''}
                            id="password-login"
                            label="Password"
                            type={values.showPassword ? 'text' : 'password'}
                            defaultValue={values.password}
                            onChange={handleChange('password')}
                            variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <StyledButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                        >
                                            {values.showPassword ? (
                                                <Visibility />
                                            ) : (
                                                <VisibilityOff />
                                            )}
                                        </StyledButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        {
                            <div
                                style={{
                                    marginTop: '8px',
                                    marginBottom: '8px',
                                    color: postData?.error ? 'red' : 'green',
                                    fontSize: '13px',
                                }}
                            >
                                {postData?.message && postData?.message.length > 1
                                    ? postData?.message.map((item, idx) => (
                                          <div key={idx}>{item}</div>
                                      ))
                                    : postData?.message}
                            </div>
                        }

                        <br />
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <StyledButton
                                disabled={!email || !password}
                                onClick={() => handleLogin()}
                                variant="contained"
                                color="primary"
                            >
                                {postData.isLoading ? (
                                    <CircularProgress
                                        style={{ height: '20px', width: '20px', color: 'white' }}
                                        color="primary"
                                    />
                                ) : (
                                    'Log in'
                                )}
                            </StyledButton>
                        </div>
                        <ForgotPasswordLink to="/forgotPassword">
                            Forgot password?
                        </ForgotPasswordLink>
                        {/* <StyledGoogleIcon
                src={GoogleIcon}
                alt="google-icon"
                onClick={() => signInWithGoogle()}
              /> */}
                    </LoginTextFieldContainer>
                </Applet>
            </AppletContainer>
        </LoginContainer>
    );
};

export default Login;
